module.exports = __webpack_public_path__ + "img/pro_04.d1b69e78.jpg";